@if (busyIndicatorMessageManager.count() > 0) {
    <ws-busy-indicator [message]="busyIndicatorMessageManager.message"></ws-busy-indicator>
}

<ws-modal-wrapper headerLabel="Assessors"
                  [suppressKeyboardEvents]="true"
                  (save)="save()"
                  (cancel)="cancel()"
                  [disableSave]="!rowsSelected">
    <div class="app-ui-view w-100">
        <ag-grid-row-count [gridApi]="gridApi"
                           [gridTracker]="gridTracker"
                           [gridOptions]="gridOptions"
                           [prefix]="null"
                           [suffix]="null"></ag-grid-row-count>
        <ws-ag-grid-angular [gridOptions]="gridOptions"
                            (gridReady)="onAgGridReady($event)">
        </ws-ag-grid-angular>
    </div>
</ws-modal-wrapper>
